(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-contact-form-popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const contactPopup = document.getElementById('contact-us-popup');
  const openPopupButton = document.querySelector('.open-contact-popup');
  const closePopupButton = document.querySelector('.close-popup');

  function openPopup() {
    contactPopup.classList.add('active');
    document.body.insertAdjacentHTML('beforeend', '<div class="popup-overlay active"></div>');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    contactPopup.classList.remove('active');
    const overlay = document.querySelector('.popup-overlay');
    if (overlay) overlay.remove();
    document.body.style.overflow = '';
  }

  if (openPopupButton && contactPopup) {
    openPopupButton.addEventListener('click', openPopup);
    closePopupButton.addEventListener('click', closePopup);

    document.body.addEventListener('click', (event) => {
      if (event.target.classList.contains('popup-overlay')) {
        closePopup();
      }
    });
  }
document.body.addEventListener('click', function(e) {
  if (e.target.closest('.close-popup')) {
    closePopup();
  }
});
  // Form submission
  const contactForm = document.getElementById('contact-us-form');
  const notification = document.getElementById('form-notification');

  if (contactForm) {
    contactForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      
      try {
        
        await new Promise(resolve => setTimeout(resolve, 800));
        
        // On success
        notification.classList.remove('hidden');
        
        // Reset form and close popup after delay
        setTimeout(() => {
          contactForm.reset();
          notification.classList.add('hidden');
          closePopup();
        }, 3000);
      } catch (error) {
        console.error('Form submission error:', error);
        // error notification here
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
